if (!customElements.get('collection-chapter-preview')) {
  customElements.define(
    'collection-chapter-preview',
    class CollectionChapterPreview extends HTMLElement {
      constructor() {
        super();
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover)');

        this.handlePointerOver = this.handlePointerOver.bind(this);
        this.handlePointerLeave = this.handlePointerLeave.bind(this);
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);
      }

      connectedCallback() {
        this.chapter = this.closest('.collection-atlas__chapter');
        this.images = Array.from(this.querySelectorAll('[data-collection-preview-image]'));
        this.captions = Array.from(this.querySelectorAll('[data-collection-preview-caption]'));

        if (!this.chapter) return;

        this.chapter.addEventListener('pointerover', this.handlePointerOver);
        this.chapter.addEventListener('pointerleave', this.handlePointerLeave);
        this.chapter.addEventListener('focusin', this.handleFocusIn);
        this.chapter.addEventListener('focusout', this.handleFocusOut);
        this.desktopMedia.addEventListener('change', this.handleViewportChange);
      }

      disconnectedCallback() {
        if (!this.chapter) return;

        this.chapter.removeEventListener('pointerover', this.handlePointerOver);
        this.chapter.removeEventListener('pointerleave', this.handlePointerLeave);
        this.chapter.removeEventListener('focusin', this.handleFocusIn);
        this.chapter.removeEventListener('focusout', this.handleFocusOut);
        this.desktopMedia.removeEventListener('change', this.handleViewportChange);
      }

      handlePointerOver(event) {
        if (!this.hoverMedia.matches) return;

        const target = event.target.closest('[data-collection-preview-target]');
        if (target && this.chapter.contains(target)) this.show(target.dataset.collectionPreviewTarget);
      }

      handlePointerLeave() {
        if (!this.hoverMedia.matches) return;

        const focusedTarget = document.activeElement?.closest?.('[data-collection-preview-target]');
        if (focusedTarget && this.chapter.contains(focusedTarget)) {
          this.show(focusedTarget.dataset.collectionPreviewTarget);
          return;
        }

        this.show('default');
      }

      handleFocusIn(event) {
        if (!this.desktopMedia.matches) return;

        const target = event.target.closest('[data-collection-preview-target]');
        if (target && this.chapter.contains(target)) this.show(target.dataset.collectionPreviewTarget);
      }

      handleFocusOut(event) {
        if (!this.desktopMedia.matches) return;

        const nextTarget = event.relatedTarget?.closest?.('[data-collection-preview-target]');
        if (nextTarget && this.chapter.contains(nextTarget)) {
          this.show(nextTarget.dataset.collectionPreviewTarget);
          return;
        }

        this.show('default');
      }

      handleViewportChange() {
        if (!this.desktopMedia.matches) this.show('default');
      }

      show(key) {
        const resolvedKey = this.images.some((image) => image.dataset.collectionPreviewImage === key)
          ? key
          : 'default';

        this.images.forEach((image) => {
          image.classList.toggle('is-active', image.dataset.collectionPreviewImage === resolvedKey);
        });
        this.captions.forEach((caption) => {
          caption.classList.toggle('is-active', caption.dataset.collectionPreviewCaption === resolvedKey);
        });
      }
    }
  );
}
